import { createStore, createHook } from "react-sweet-state";
import { addScheduleApi } from "../api";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    loading: true,
    form: {
      personId: "",
      date: "",
      shiftId: ""
    },
    error: null,
  },
  // actions that trigger store mutation
  actions: {
    updateForm:
      (updateForm) =>
      async ({ setState, getState }) => {
        const replaceForm = { ...getState().form, ...updateForm };

        setState({ form: replaceForm });
    },
    createData:
      (onSuccess) =>
      async ({ setState, getState }) => {
        setState({ isLoading: true, error: null });
        try {
          await addScheduleApi(getState().form);
          setState({ isLoading: false });
          if (onSuccess) {
            onSuccess();
          }
          return;
        } catch (err) {
          setState({
            error:
              err && err.response ? err.response.data : "Unknow add data error",
          });
        }

        setState({ isLoading: false });
      },
  },
  // optional, mostly used for easy debugging
  name: "addScheduleService",
});

export const useAddSchedule = createHook(Store);
